import React from 'react';
import {StandingsWidgetRecentFormBadge} from "../elements/standings-widget.recent-form.badge";
import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {TableCell} from "../../../../core/components/table/table-cell";
import {StandingsWidgetRecentFormGameViewModel} from "../../models/standings-widget.recent-form-game.view-model";
import {StandingsWidgetController} from "../../standings-widget.controller";
import classNames from "classnames";
import styles from "../../styles/standings-widget.module.scss"
import {StandingWidgetCompetitorViewModel} from "../../models/standings-widget.competitor-view-model";
import {StandingsWidgetRecentFormBadgeDataLess} from "../elements/standings-widget.recent-form.badge-data-less";

export class StandingsWidgetTableFormCellProps extends BaseProps {
  controller: StandingsWidgetController;
  cell: Array<StandingsWidgetRecentFormGameViewModel>;
  competitor: StandingWidgetCompetitorViewModel;
}

export const StandingsWidgetTableFormCell = ({
                                               controller,
                                               cell,
                                               competitor,
                                               hasBorder
                                             }: StandingsWidgetTableFormCellProps) => {

  return (
    <TableCell className={classNames(styles.table_form_cell, {[styles.table_cell_border]: hasBorder})}>
      {
        cell.value.map((game, index) => {
          if (typeof game === 'number') {
            // If `game` is a number, render a different component
            return <StandingsWidgetRecentFormBadgeDataLess key={index} winnerStatus={game} controller={controller}/>;
          } else {
            return (
                <StandingsWidgetRecentFormBadge
                    controller={controller}
                    game={game}
                    competitor={competitor}
                    key={index}
                />
            );
          }
        })
      }
    </TableCell>
  )
}
